import Delete from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import { Component } from 'react';
import { connect } from 'react-redux';
import { confirmAction, showError, showMessage } from '../../actions/uiActions';
import EinApi from '../../api/eins';
import PaginatedTable from '../../components/PaginatedTable';
import { withRouter } from '../../utils/withRouter';
import TerminationDeleteConfirmationModal from './terminationDeleteConfirmationModal';
import { debounce } from 'lodash';
import { TextField } from '@mui/material';

class Terminations extends Component
{
    state = {
        loading: true,
        isEmpty: false,
        deleting: false,
        user: null,
        users: [],
        count: 0,
        page: 0,
        confirmTermDelete: false,
        sort: {},
        activeQuery: {
            order: 'desc', orderBy: 'terminatedDate'
        },
        search: ''
    }

    constructor(props)
    {
        super(props)
        this.debouncedSearch = debounce((search) =>
        {
            this.getTerminatedUsers(0, { search });
        }, 500);
    }
    componentDidMount()
    {
        this.getTerminatedUsers(this.state.page);
    }

    getTerminatedUsers = async (page, params) =>
    {
        try
        {
            const result = await EinApi.getTerminatedUsers(this.props.match.params.domainId, page, { ...this.state.activeQuery, ...params })
            if (result)
            {
                this.setState({ loading: false, users: result.users, page: result.page, pages: result.pages, count: result.count })
            }
        } catch (error)
        {
            this.setState({ loading: false }, this.props.showError)
        }
    }

    openConfirmDeleteModal = (user) => this.setState({ user, confirmTermDelete: true })

    searchTerminations = async (e) =>
    {
        const value = e.target.value;
        if (!value)
        {
            this.getTerminatedUsers(this.state.page)
            this.setState({ search: '' });
        }
        this.setState({ search: value });
        this.debouncedSearch(value);
    }


    delete = (excludeUserFromCensus = false) =>
    {
        const user = this.state.user
        this.setState({ deleting: true }, () =>
        {
            if (user.terminatedDate)
            {
                EinApi.removeTerminatedUser(user._id, this.props.match.params.domainId, excludeUserFromCensus).then(success =>
                {
                    this.props.showMessage("User removed successfully");
                    this.setState({ deleting: false, user: null, confirmTermDelete: false })
                    this.getTerminatedUsers();
                }, error => this.setState({ deleting: false, user: null }, this.props.showError))
                    .catch(error => this.setState({ deleting: false, user: null }, this.props.showError))
            } else
            {
                this.props.showMessage("User is not in the terminated list");
                this.setState({ deleting: false, user: null, })
            }
        })
    }

    handleSort = ({ order, orderBy }) =>
    {
        this.setState(
            { sort: { ...this.state.sort, [orderBy]: order }, activeQuery: { order, orderBy } }, () => this.getTerminatedUsers(this.state.page, { order, orderBy })
        );
    }

    render()
    {
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className='form-group nice' style={{ textAlign: "right" }}>
                            <TextField placeholder='Search terminated users by name, email etc.' label="Search Terminations:" sx={{
                                width: '500px',
                                marginTop: -5
                            }} value={this.state.search} onChange={this.searchTerminations} />
                        </div>
                        <Paper style={{ overflowX: 'auto' }}>
                            <PaginatedTable goToPage={this.getTerminatedUsers} count={parseInt(this.state.count.toString())} page={parseInt(this.state.page.toString())} loading={this.state.loading} rows={this.state.users.map(user =>
                            {
                                return {
                                    properties: {
                                        key: user._id
                                    },
                                    columns:
                                        [
                                            {
                                                properties: {
                                                    key: `${user._id}-1`
                                                },
                                                value: `${user.firstname}`
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-2`
                                                },
                                                value: `${user.lastname}`
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-3`
                                                },
                                                value: user.email
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-4`
                                                },
                                                value: user.secondary_email
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-5`
                                                },
                                                value: user.employerKey
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-6`
                                                },
                                                value: moment.unix(user.terminatedDate).format("MM/DD/YYYY")
                                            },
                                            {
                                                properties: {
                                                    key: `${user._id}-7`
                                                },
                                                value: <div className="text-centers">
                                                    {this.state.user && this.state.user._id == user._id ? <CircularProgress size={24} /> :
                                                        <>
                                                            <Tooltip title="Delete terminated user">
                                                                <IconButton disabled={this.state.deleting && this.state.user && this.state.user?._id == user?._id} onClick={() => this.openConfirmDeleteModal(user)}>
                                                                    <Delete />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    }

                                                </div>
                                            }
                                        ]
                                };
                            })}
                                emptyMessage="No terminated users found"
                                columns={[
                                    {
                                        name: "First Name",
                                        properties:
                                        {
                                            key: 1,
                                            className: "width30pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.firstname === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.firstname === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'firstname'
                                            this.handleSort({ order, orderBy })
                                        }
                                    },
                                    {
                                        name: "Last Name",
                                        properties:
                                        {
                                            key: 2,
                                            className: "width30pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.lastname === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.lastname === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'lastname'
                                            this.handleSort({ order, orderBy })
                                        }
                                    },
                                    {
                                        name: "Email",
                                        properties:
                                        {
                                            key: 3,
                                            className: "width40pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.email === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.email === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'email'
                                            this.handleSort({ order, orderBy })
                                        }
                                    },
                                    {
                                        name: "Secondary Email",
                                        properties:
                                        {
                                            key: 4,
                                            className: "width40pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.secondary_email === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.secondary_email === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'secondary_email'
                                            this.handleSort({ order, orderBy })
                                        }
                                    },
                                    {
                                        name: "Employee ID",
                                        properties:
                                        {
                                            key: 5,
                                            className: "width40pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.employerKey === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.employerKey === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'employerKey'
                                            this.handleSort({ order, orderBy })

                                        }
                                    },
                                    {
                                        name: "Termination Date",
                                        properties:
                                        {
                                            key: 6,
                                            className: "width40pct"
                                        },
                                        sortable: true,
                                        asc: this.state.sort.terminatedDate === 'asc',
                                        onClick: () =>
                                        {
                                            const order = this.state.sort.terminatedDate === 'asc' ? 'desc' : 'asc'
                                            const orderBy = 'terminatedDate'
                                            this.handleSort({ order, orderBy })

                                        }
                                    },
                                    {
                                        name: "Options",
                                        properties:
                                        {
                                            key: 7,
                                            className: "width40pct"
                                        }
                                    }
                                ]} />
                        </Paper>
                    </div>
                </div>
                {/* Modal Area */}
                {this.state.confirmTermDelete && this.state.user?._id && < TerminationDeleteConfirmationModal onCancel={() => this.setState({ confirmTermDelete: false, user: null })} loading={this.state.deleting} action={this.delete} />}
            </div>
        )
    }
}
export default withRouter(connect(null, { showError, showMessage, confirmAction })(Terminations));